/**
 * Vuetify colors scheme to be used in the layout
 */
const vuetifyColors = {
  grey: "#BBBBBB",
  black: "#212121",
  lightGrey: "#f5f5f5",
  background: "#FBFBFB",
};

/**
 * Vuetify global theme configuration for the inboxaware application
 */
const vuetifyConfig = {
  theme: {
    light: true,
    themes: {
      light: {
        //primary: vuetifyColors.black,
        grey: vuetifyColors.grey,
        "light-grey": vuetifyColors.lightGrey,
        background: vuetifyColors.background,
        black: vuetifyColors.black,
        error: "#B00020",
        primary: "#006BAF",
        mpBlue: '#03b6fc',
        mpPink: '#F53BAD',
      },
    },
  },
};

export default Object.freeze(vuetifyConfig);
